import React from "react";
import { Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Title } = Typography;

const NewSettingsHeader = ({
  headerText,
  className = "",
  showBack = false,
  onBack,
  actions,
  extra,
  level = 3,
  textClassName = "text-xl mb-4 font-semibold",
}) => {
  return (
    <div className={`flex items-center justify-between ${className}`}>
      <div className="flex items-center gap-2">
        {showBack && (
          <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} className="mr-2" />
        )}
        <Title level={level} className={`!mb-0 ${textClassName}`}>
          {headerText}
        </Title>
      </div>
      <div className="flex items-center gap-2">
        {actions}
        {extra}
      </div>
    </div>
  );
};

export default NewSettingsHeader;
